export default __webpack_public_path__ + "static/media/Shopping.9aa3b3ce.svg";